import { CalendarPrimeReact } from "@finanedi.es/storybook"
import { useCuentasBancariasAll } from "api/CuentaBancaria.hook"
import CustomButton from "common/components/Button/Button"
import FormikDropdown from "common/components/FormikFields/FormikDropdown"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import { PAYMENT_TYPE } from "common/utils/constants"
import { DEFAULT_CURRENCY_SYMBOL } from "features/Contactos/constants"
import { ImporteBodyTemplate } from "features/Documentos/templates"
import { ErrorMessage } from "formik"
import { InputText } from "primereact/inputtext"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { getDropdownBankValues } from "./constants"
import "./styles.scss"

const RemesaForm = ({
  hideModal,
  handleChange,
  setFieldValue,
  values,
  handleSubmit,
  handleBlur,
  isEditView,
  data,
}: $TSMigrationFixMe) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const { cuentaBancariaAll } = useCuentasBancariasAll({})
  const [selectedAccount, setSelectedAccount] = useState()

  useEffect(() => {
    if (isEditView && cuentaBancariaAll?.items?.length) {
      setSelectedAccount(
        // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
        cuentaBancariaAll?.items.find(
          (cta) => cta.id === values?.cuentaBancariaId
        )
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditView, cuentaBancariaAll?.items, values?.cuentaBancariaId])

  const onSubmit = (e: $TSMigrationFixMe) => {
    e.preventDefault()

    handleSubmit(values)
  }

  const handleDate = (e: $TSMigrationFixMe) => {
    setFieldValue("fechaVencimiento", e.target.value)
  }

  const handleBankAccount = ({ value }: $TSMigrationFixMe) => {
    setFieldValue("cuentaBancariaId", value.id)
    setSelectedAccount(value)

    if (data.tipo === PAYMENT_TYPE.PAGO) {
      value?.identificadores?.presentador &&
        setFieldValue("identificador", value?.identificadores?.presentador)
    } else {
      value?.identificadores?.acreedor &&
        setFieldValue("identificador", value?.identificadores?.acreedor)
    }
  }

  return (
    <form onSubmit={onSubmit}>
      <div className='mb-3 p-fluid'>
        <div className='subtitle_container'>
          <h6 className='text__simple'>{t("remesas.edit.form.title")}</h6>

          <ImporteBodyTemplate
            importe={data?.total}
            divisa={DEFAULT_CURRENCY_SYMBOL}
          />
        </div>
      </div>
      <div className='mb-3 select_container'>
        <label htmlFor='tipoDocumento'>
          {t("remesas.edit.form.conceptLabel")}
        </label>
        <FormikInputText
          id='concepto'
          name='concepto'
          onChange={handleChange}
          type='text'
          value={values.concepto}
          onBlur={handleBlur}
        />
      </div>
      <div className='mb-3 select-main_content'>
        <div className='select_container'>
          <label htmlFor='fechaVencimiento'>
            {t("remesas.edit.form.dateMaturityLabel")}
          </label>
          <CalendarPrimeReact
            id='fechaVencimiento'
            name='fechaVencimiento'
            clearButtonClassName='!tw-hidden'
            value={new Date(values?.fechaVencimiento)}
            onChange={handleDate}
            onBlur={handleBlur}
            locale={language}
            placeholder='dd/mm/aaaa'
            dateFormat='dd/mm/yy'
            className='tw-w-full'
            showIcon
          />

          <ErrorMessage
            name='fechaVencimiento'
            className='tw-text-danger tw-text-left tw-text-xs'
            component='div'
          />
        </div>
      </div>
      <div className='mb-3 select_container'>
        <label htmlFor='tipoDocumento'>
          {t("remesas.edit.form.accountLabel")}
        </label>
        <FormikDropdown
          options={getDropdownBankValues(cuentaBancariaAll?.items)}
          value={selectedAccount}
          onChange={(value: $TSMigrationFixMe) => handleBankAccount(value)}
          placeholder={t("remesas.edit.form.placeholderAccount")}
          emptyFilterMessage={t("remesas.edit.form.emptyMsg")}
          emptyMessage={t("remesas.edit.form.emptyMsg")}
          fluid
          id='cuentaBancariaId'
          name='cuentaBancariaId'
          onBlur={handleBlur}
          panelClassName='!tw-z-[2302]'
        />
      </div>
      <div className='mb-3 select_container'>
        <label htmlFor='tipoDocumento'>
          {t("remesas.edit.form.swiftBicLabel")}
        </label>
        <InputText
          onChange={handleChange}
          type='text'
          // @ts-expect-error TS(2339): Property 'bic' does not exist on type 'never'.
          value={selectedAccount?.bic}
          onBlur={handleBlur}
          disabled
        />
      </div>
      <div className='mb-3 select_container'>
        <label htmlFor='tipoDocumento'>
          {data?.tipo === PAYMENT_TYPE.PAGO
            ? `${t("remesas.edit.form.idRepresentativeLabel")}`
            : `${t("remesas.edit.form.idCreditorLabel")}`}
        </label>
        <FormikInputText
          id='identificador'
          name='identificador'
          onChange={handleChange}
          type='text'
          value={values?.identificadorPresentador}
          onBlur={handleBlur}
        />
      </div>
      {isEditView ? null : (
        <div className='departaments-modal__actions'>
          <p onClick={() => hideModal()}>
            {t("remesas.edit.form.cancelButton")}
          </p>
          <CustomButton
            type='submit'
            className='tw-ml-2 !tw-bg-primary tw-cursor-pointer'
          >
            {t("remesas.edit.form.createButton")}
          </CustomButton>
        </div>
      )}
    </form>
  )
}

export default RemesaForm
